import React from 'react';
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl';
import PrimaryButton from '../form-components/PrimaryButton/PrimaryButton';
import SecondaryButton from '../form-components/SecondaryButton/SecondaryButton';
import { IPopupable } from '../Popup/Popup';
import globalMessages from 'src/services/globalMessages';


interface IConfirmationProps extends IPopupable {
    description: MessageDescriptor;
    affirmativeAction: () => void;
    affirmativeCaption: MessageDescriptor;
    dangerous?: boolean;
    warning?: MessageDescriptor;
}

const messages = defineMessages({
    confirmationHeader: {
        id: 'confirmationHeader',
        defaultMessage: 'Megerősítés'
    },
});

const Confirmation: React.FunctionComponent<IConfirmationProps> = (props) => {

    const handleOk = () => {
        if (props.closePopup) { props.closePopup(); }
        props.affirmativeAction();
    }

    return (
        <section className="confirmation">
            <h2 className="confirmation__header"><FormattedMessage {...messages.confirmationHeader} /></h2>
            {props.warning && <p className="confirmation__warning"><FormattedMessage {...props.warning} /></p>}
            <p className="confirmation__description"><FormattedMessage {...props.description} /></p>
            <div className="confirmation__buttons">
                {props.closePopup && <SecondaryButton className="confirmation__button" caption={globalMessages.cancel} onClick={props.closePopup} />}
                <PrimaryButton className="confirmation__button" dangerous={props.dangerous} onClick={handleOk} caption={props.affirmativeCaption} />
            </div>
        </section>
    )
}

export default Confirmation;
